import { DateCell } from 'components/DataTableTest'

export default ({ t, locales, showInterval, creditCols }) => ([
	{
		caption: t('common.dates.day'),
		dataField: 'dateTime',
		cellRender: DateCell({ locales }),
		groupCellRender: DateCell({ locales })
	}, { ...showInterval && {
		caption: t('common.fields.time'),
		dataField: 'interval'
	} }, {
		caption: t('common.fields.total_price'),
		dataField: 'total',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum',
			name: 'totalPrice'
		},
		groupSummary: {
			summaryType: 'sum',
			alignByColumn: true,
			name: 'groupTotalPrice'
		}
	}, {
		caption: t('statistic_section.strings.customers'),
		dataField: 'billCount',
		summary: {
			summaryType: 'sum',
			name: 'billCount'
		},
		groupSummary: {
			summaryType: 'sum',
			name: 'groupBillCount',
			alignByColumn: true
		},
	}, {
		caption: `${t('common.fields.total_price')}/${t('statistic_section.strings.customers')}`,
		dataField: 'totalK',
		localFormat: { type: 'float' },
		summary: {
			calculateCustomSummary: options => {
				const { name, summaryProcess, value } = options
				if(name === 'totalPerCustomers') {
					const totalSum = options?.component?.getTotalSummaryValue?.('totalPrice')
					const totalBills = options?.component?.getTotalSummaryValue?.('billCount')
					if(totalSum && totalBills) {
						options.totalValue = totalSum / totalBills
					}
				}
				if(name === 'totalPerGroup') {
					switch(summaryProcess) {
						case 'start':
							options.totalValue = []
							break
						case 'calculate':
							options.totalValue.push(value)
							break
						case 'finalize':
							const { sum, billCount } = options.totalValue.reduce((acc, item) => {
								acc.sum += (item.total || 0)
								acc.billCount += (item.billCount || 0)
								return acc
							}, { sum: 0, billCount: 0 })
							options.totalValue = sum / billCount
							break
						default: break
					}
				}
			},
			summaryType: 'custom',
			name: 'totalPerCustomers'
		},
		groupSummary: {
			summaryType: 'custom',
			name: 'totalPerGroup',
			alignByColumn: true,
			column: null,
			showInColumn: 'totalK'
		}
	}, {
		caption: t('statistic_section.strings.credit_customer'),
		dataField: 'creditClient',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum'
		},
		groupSummary: {
			summaryType: 'sum',
			alignByColumn: true
		},
		visible: !!creditCols
	}, {
		caption: `${t('statistic_section.strings.customers')} KK`,
		dataField: 'creditClientCount',
		summary: {
			summaryType: 'sum'
		},
		groupSummary: {
			summaryType: 'sum',
			alignByColumn: true
		},
		visible: !!creditCols
	}, {
		caption: `KK/${t('statistic_section.strings.customers')} KK`,
		dataField: 'creditClientTotal',
		localFormat: { type: 'float' },
		summary: {
			summaryType: 'sum'
		},
		groupSummary: {
			summaryType: 'sum',
			alignByColumn: true
		},
		visible: !!creditCols
	}
])
